<template>
    <v-container>
        <v-row>
            <v-col cols="cols">
                privacy
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  export default {
    name: 'Privacy'
  }
</script>

<style scoped>

</style>
